<template>
  <tsl-container v-if="isCurrent">
    <template v-slot:left>
      <version-upgrade></version-upgrade>
      <alarm-overview></alarm-overview>
      <devops-cost></devops-cost>
    </template>
    <template v-slot:right>
      <need-to></need-to>
      <access-ontrol></access-ontrol>
      <system-backup></system-backup>
      <operational-audit></operational-audit>
    </template>
  </tsl-container>
  <router-view v-else />
</template>
<script>
import Container from "@/components/tsl-container/index.vue";
import Alarm from "@/components/dashboard/devops/alarm-overview.vue";
import Version from "@/components/dashboard/devops/version-upgrade.vue";
import System from "@/components/dashboard/devops/system-backup.vue";
import Need from "@/components/dashboard/devops/need-to.vue";
import Access from "@/components/dashboard/devops/access-ontrol.vue";
import Operational from "@/components/dashboard/devops/operational-audit.vue";
import Cost from "@/components/dashboard/devops/devops-cost.vue";
import { computed } from "vue";
import { useRouter } from "vue-router";
export default {
  components: {
    [Container.name]: Container,
    [Alarm.name]: Alarm,
    [Version.name]: Version,
    [System.name]: System,
    [Need.name]: Need,
    [Access.name]: Access,
    [Operational.name]: Operational,
    [Cost.name]: Cost
  },
  setup() {
    const router = useRouter();
    const { path } = router.currentRoute.value;
    const isCurrent = computed(() => ["/dashboard/devops", "/dashboard/devops/"].includes(path));
    return {
      isCurrent
    };
  }
};
</script>
